<template>
  <div>
    <div class="commpany">
      <div class="commpany_text">
        <p class="commpany_Title">{{ enterDetails.enterpriseName }}</p>
        <p class="commpany_meg">{{ enterDetails.details }}</p>
        <div class="commpany_btn">
          <div
            class="commpany_btn_box"
            v-if="enterDetails.vrUrl"
            @click="goToParkVr(enterDetails)"
          >
            <i class="iconfont">&#xe635;</i>
            <span>VR</span>
          </div>
          <span v-if="enterDetails.url" @click="goToParkVr(enterDetails)"
            >详情 ></span
          >
        </div>
      </div>
      <div class="commpany_img">
        <img :src="enterDetails.thumbnail" alt="" />
      </div>
    </div>

    <div class="swiper-container swiper-container2">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide enterprise_box"
          v-for="(items, index) in enterPriseList"
          :key="index"
        >
          <div
            class="park_swipers enterprise_box_logo"
            @mouseover="updateSwiperInfo(index)"
          >
            <img :src="items.logoUrl" alt="" />
            <p
              :style="{
                color: items.uuid === enterDetails.uuid ? '#000000' : '#6E6E6E',
              }"
            >
              {{ items.enterpriseName }}
            </p>
          </div>
        </div>
      </div>

      <div class="swiper-button-prev" @click="prevSwiperInfo"></div>
      <div class="swiper-button-next" @click="nextSwiperInfo"></div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import {
  getEnterpriseMangeList,
} from "../../utils/interface";
export default {
  data() {
    return {
      swiperIndex: 0,
      effect: 0,
      slides: ["Slide 1", "Slide 2", "Slide 3", "Slide 4", "Slide 5"],
      enterPriseList: [],
      enterDetails: {},
    };
  },
  created() {
     // 重点企业
     this.getEnterpriseMangeList();
  },
  methods: {
      // 重点企业
      getEnterpriseMangeList() {
        let enterpriseParam = {
            isKeyEnterprise: true,
            current: 1,
            pageSize: 24,
        };
        getEnterpriseMangeList(enterpriseParam).then((res) => {
            this.enterPriseList = res.list
            this.enterDetails = res.list[0]
            this.$nextTick(() => {
            //   // 进行初始化 延迟执行，确保数据已经渲染完成
                this.handSwiper();
            });
        });
    },
    updateSwiperInfo(index) {
      this.swiperIndex = index;
      this.enterDetails = this.enterPriseList[index];
    },
    prevSwiperInfo() {
      if (this.swiperIndex > 0) {
        this.swiperIndex = this.swiperIndex - 1;
        this.enterDetails = this.enterPriseList[this.swiperIndex];
      }
    },
    nextSwiperInfo() {
      if (this.swiperIndex < this.enterPriseList.length - 1) {
        this.swiperIndex = this.swiperIndex + 1;
        this.enterDetails = this.enterPriseList[this.swiperIndex];
      } else {
        this.swiperIndex = 0;
        this.enterDetails = this.enterPriseList[this.swiperIndex];
      }
    },
    handSwiper() {
      let effectIn = this.effect;
      let emterSwiper = new Swiper(".swiper-container2", {
        initialSlide: 0,
        loop: true,
        loopAdditionalSlides: 3,
        speed: 1000,
        slidesPerView: 4,
        spaceBetween: 0,
        centeredSlides: false,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        on: {
          setTranslate() {
            let slides = this.slides;
            for (var i = 0; i < slides.length; i++) {
              let slide = slides.eq(i);
              let progress = slides[i].progress;
              //slide.html(progress.toFixed(2)); 看清楚progress是怎么变化的
              slide.css({ opacity: "", background: "" });
              slide.transform(""); //清除样式
              if (effectIn == 1) {
                slide.transform("scale(" + (1 - Math.abs(progress) / 8) + ")");
              }
            }
          },
          setTransition(transition) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              slide.transition(transition);
            }
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: {
          delay: 1500,
          stopOnLastSlide: false,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
          autoplayDisableOnInteraction: false,
        },
      });
      //鼠标覆盖停止自动切换
      console.log(1111, emterSwiper.el)
      emterSwiper.el.onmouseover = function() {
        emterSwiper.autoplay.stop();
      };

      //鼠标离开开始自动切换
      emterSwiper.el.onmouseout = function() {
        emterSwiper.autoplay.start();
      };
    },
  },
};
</script>
<style scoped lang="less">
.enterprise_box {
    .enterprise_box_logo {
        border: 1px solid #efefef;
        margin: 38px 0 77px;
       img {
            width: 226px;
            height: 134px;
            background: #fff;
            cursor: pointer;
            display: block;
       }
       p {
        font-size: 16px;
            background: #f2f2f2;
            text-align: center;
            padding: 12px 0;
       }
    }
}
.commpany {
  display: flex;
  padding: 10px 10px 10px 32px;
  background: url("../../assets/parkComBack.jpg") no-repeat;
  background-size: 100% 100%;
  font-size: 16px;

  .commpany_text {
    width: 50%;
    margin-top: 40px;
  }

  .commpany_Title {
    font-size: 24px;
    font-weight: 500;
    margin-bottom: 22px;
  }

  .commpany_meg {
    margin-bottom: 39px;
    margin-right: 80px;
    line-height: 32px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #6e6e6e;
    display: -webkit-box;
    overflow: hidden;
    white-space: normal !important;
    text-overflow: ellipsis;
    word-wrap: break-word;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
  }

  .commpany_btn {
    display: flex;
    align-items: center;

    .commpany_btn_box {
      color: #6e6e6e;
      font-size: 14px;
      padding: 3px 5px;
      margin-right: 10px;
      border-radius: 4px;
      cursor: pointer;
    }

    span {
      cursor: pointer;
      font-size: 14px;
      color: #6e6e6e;
    }
  }

  .commpany_img {
    width: 594px;
    height: 344px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.swiper-container {
  width: 1200px;
  height: auto;
  margin: 0 auto;
  padding: 0 0 90px;
}
.swiper-wrapper {
  width: 1200px;
  margin: 0 auto;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  height: 200px;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  transition-property: all;
  margin-right: 0 !important;
}
.swiper-slide {
  height: 100%;
  border-radius: 10px;
  background: none;
}
.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  left: 0;
  height: 45px;
  --swiper-navigation-size: 26px !important;
  top: 38%;
  transform: translate(0, -55%);
}
.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  right: 0px;
  height: 45px;
  --swiper-navigation-size: 26px !important;
  top: 38%;
  transform: translate(0, -55%);
}
</style>



// WEBPACK FOOTER //
// src/components/parkSwiper/emterSwiper.vue